import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  eventImagePopupContainer: {
    position: "fixed",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    border: "1px solid #EAEAEA",
    borderRadius: 10,
    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      "@media (orientation: landscape)": {
        width: "100vh",
      },

      "@media (orientation: portrait)": {
        width: "100vw",
      },
    },
  },

  image: {
    objectFit: "cover",
    width: "100%",
    display: "block",
    height: "100%",
  },

  closeButton: {
    position: "absolute",
    color: "white",
    backgroundColor: "rgba(10, 10, 10, 0.2)",
    top: 10,
    right: 10,
  },
}));
